import { Link } from "react-router-dom";
import { Heart, Play, BadgeCheck, MapPin } from "lucide-react";
import { formatFCFA, mediaSrc } from "@/lib/api";

export default function ProductCard({ product, onFavorite, isFav }) {
  const img = (product.images && product.images[0]) || null;
  const hasVideo = !!product.video;
  const verified = product.shop?.verified;

  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block rounded-xl overflow-hidden bg-white border border-[#E8E6E1] active:scale-[0.98] transition"
    >
      <div className="relative aspect-square bg-[#F3F1EC] overflow-hidden">
        {img ? (
          <img src={mediaSrc(img)} alt={product.title} className="h-full w-full object-cover" loading="lazy" />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-[#73706B] text-xs">Sans image</div>
        )}
        {hasVideo && (
          <div className="absolute top-2 left-2 flex items-center gap-1 bg-black/70 text-white text-[10px] font-bold px-2 py-1 rounded-md">
            <Play className="h-3 w-3 fill-current" /> VIDÉO
          </div>
        )}
        {product.wholesale && (
          <div className="absolute bottom-2 left-2 bg-[#1A1918] text-white text-[10px] font-bold px-2 py-1 rounded-md">
            GROS
          </div>
        )}
        {onFavorite && (
          <button
            type="button"
            data-testid={`fav-btn-${product.id}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onFavorite(product.id); }}
            className="absolute top-2 right-2 h-8 w-8 rounded-full bg-white/95 flex items-center justify-center shadow-sm hover:scale-110 transition"
          >
            <Heart className={`h-4 w-4 ${isFav ? "fill-[#E65100] text-[#E65100]" : "text-[#1A1918]"}`} />
          </button>
        )}
      </div>
      <div className="p-3">
        <div className="font-bold text-[#E65100] text-base">{formatFCFA(product.price)}</div>
        <div className="mt-1 text-sm text-[#1A1918] line-clamp-2 leading-snug">{product.title}</div>
        <div className="mt-2 flex items-center gap-1 text-[11px] text-[#73706B]">
          {verified && <BadgeCheck className="h-3 w-3 text-[#0A7D3A]" />}
          <span className="truncate">{product.shop?.name || "Boutique"}</span>
          {product.shop?.city && (
            <>
              <span>·</span>
              <MapPin className="h-3 w-3" />
              <span className="truncate">{product.shop.city}</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
